<template>
  <!-- <div class="form-row"> -->
  <!-- <div class="form-group col-md-3 mb-0" > -->
  <!-- <label class="custom-wrap"> -->
  <!-- <select v-model="selectedBulkAction" class="form-control go-custom-select"  style="max-width:200px; margin-bottom:15px;" @change="selectAction()"> -->
  <!-- <option hidden>Action</option> -->
  <!-- <option :disabled="campaignGroupSelectedList.length<1">Create Guardrail</option> -->
  <!-- </select> -->
  <!-- </label> -->
  <!-- </div> -->
  <!-- </div> -->
  <div>
    <div
      class="dropdown-menu remove-style"
      aria-labelledby="dropdownMenuButton"
    >
	<a
      class="dropdown-item"
      style="cursor: pointer"
      href="javascript:void(0)"
      @click="selectAction()"
      :disabled="campaignGroupSelectedList.length < 1"
    >Create Guardrail</a></div>
    
  </div>
</template>

<script>
// import AddGuardrail from "@/components/campaign-list/AddGuardrail.vue";

export default {
  name: "CampaignGroupActions",
  components: {
    //AddGuardrail
  },
  data() {
    return {
      selectedBulkAction: "Action",
    };
  },
  computed: {
    campaignGroupSelectedList: {
      get() {
        return this.$store.state.campaign.campaignGroupSelectedList;
      },
      set(val) {
        this.$store.state.campaign.campaignGroupSelectedList = val;
      },
    },
    actionSelectioncampaignGroupControl: {
      set(val) {
        this.$store.state.campaign.actionSelectioncampaignGroupControl = val;
      },
      get() {
        return this.$store.state.campaign.actionSelectioncampaignGroupControl;
      },
    },
  },
  methods: {
    selectAction() {
      // if (this.selectedBulkAction == "Create Guardrail") {
      //   //this.showguardrail = true;
      //   let path = "/AddGuardrail/campaign_group";
      //   this.$router.push({ path: path });
      // }
      this.$router.push({
        path: '/addEditGuardrail/' + 'null' + '/myAutomation' + '/campaign_group'
      });
    },
  },
};
</script>

<style lang="scss">
</style>
